export default __webpack_public_path__ + "static/media/card5.ec9818d9.png";